import PropTypes from 'prop-types';
import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import { StatusTypes } from '@dashboard-experience/utils';
import FlaggedStatusBadge from 'components/StatusBadge/FlaggedStatusBadge';
import { InternationalCreditRecordObject } from '../../../../../types/report';
import {
  InternationalCreditReportRecordBox,
  InternationalCreditReportRecordLine,
  InternationalCreditBoldCaption,
} from './InternationalCreditStyledComponents';

interface InternationalCreditReportEmptyRecordProps {
  record: InternationalCreditRecordObject;
}

const InternationalCreditEmptyReportRecord = ({
  record,
}: InternationalCreditReportEmptyRecordProps) =>
  !!record && (
    <div>
      <InternationalCreditReportRecordBox>
        <InternationalCreditReportRecordLine>
          <InternationalCreditBoldCaption>
            {record.countryName}{' '}
            {i18n.getStr('components.internationalCreditReportCaption')}
          </InternationalCreditBoldCaption>
        </InternationalCreditReportRecordLine>
        <div>
          <FlaggedStatusBadge
            statusType={StatusTypes.Legacy}
            status='pending'
          />
        </div>
      </InternationalCreditReportRecordBox>
    </div>
  );

InternationalCreditEmptyReportRecord.propTypes = {
  record: PropTypes.object,
};

InternationalCreditEmptyReportRecord.defaultProps = {
  record: {},
};

export default i18n.renderTranslation()(InternationalCreditEmptyReportRecord);
